import { Controller } from "@hotwired/stimulus"

// Collapsible admin form sections — click title to toggle
export default class extends Controller {
  static targets = ["body"]

  connect() {
    // Start collapsed if it has the 'collapsed' class
    if (this.element.dataset.collapseDefault === "closed") {
      this.bodyTarget.style.display = "none"
      this.element.classList.add("is-collapsed")
    }
  }

  toggle() {
    const isOpen = this.bodyTarget.style.display !== "none"
    this.bodyTarget.style.display = isOpen ? "none" : ""
    this.element.classList.toggle("is-collapsed", isOpen)
  }
}
